import { __rest } from '../../../_virtual/_tslib.js';
import React from 'react';
import PropTypes from 'prop-types';
import { getDayEnd, getDayStart } from '@wojtekmaj/date-utils';
import Tile from '../Tile.js';
import { isWeekend } from '../shared/dates.js';
import { formatDay, formatLongDate } from '../shared/dateFormatter.js';
import { tileProps } from '../shared/propTypes.js';

const className = 'react-calendar__month-view__days__day';
function Day(_a) {
  var {
      formatDay: formatDay$1 = formatDay,
      formatLongDate: formatLongDate$1 = formatLongDate,
      calendarType,
      classes,
      currentMonthIndex
    } = _a,
    otherProps = __rest(_a, ["formatDay", "formatLongDate", "calendarType", "classes", "currentMonthIndex"]);
  const {
    date,
    locale
  } = otherProps;
  return React.createElement(Tile, Object.assign({}, otherProps, {
    classes: [].concat(classes, className, isWeekend(date, calendarType) ? `${className}--weekend` : null, date.getMonth() !== currentMonthIndex ? `${className}--neighboringMonth` : null),
    formatAbbr: formatLongDate$1,
    maxDateTransform: getDayEnd,
    minDateTransform: getDayStart,
    view: "month",
    tabIndex: date.getMonth() !== currentMonthIndex ? -1 : undefined,
    isNeighboringMonth: date.getMonth() !== currentMonthIndex
  }), formatDay$1(locale, date));
}
Day.propTypes = Object.assign(Object.assign({}, tileProps), {
  currentMonthIndex: PropTypes.number.isRequired,
  formatDay: PropTypes.func,
  formatLongDate: PropTypes.func
});

export { Day as default };
